import { conexaoTypes } from './../../constants/conexao.constants'

const initialState = {
	ehConexaoIda: false,
	ehConexaoVolta: false,
	conexaoIda: null,
	conexaoVolta: null,
	ordemViagemIda: 0,
	ordemViagemVolta: 0,
	quantidadeViagensIda: 0,
	quantidadeViagensVolta: 0,
	conexaoIdaId: null,
	conexaoVoltaId: null,
}

function getOrdemViagemIda() {
	return {
		type: conexaoTypes.ObterOrdemViagemIda,
	}
}

function getConexaoState() {
	return {
		type: conexaoTypes.ObterConexao,
	}
}

function setViagemIda(conexao) {
	return {
		type: conexaoTypes.AdicionarConexaoIda,
		payload: conexao,
	}
}

function setViagemVolta(conexao) {
	return {
		type: conexaoTypes.AdicionarConexaoVolta,
		payload: conexao,
	}
}

function setOrdemViagemIda() {
	return {
		type: conexaoTypes.OrdemViagemIda,
	}
}

function setOrdemViagemVolta() {
	return {
		type: conexaoTypes.OrdemViagemVolta,
	}
}

function resetConexaoState() {
	return {
		type: conexaoTypes.ResetConexao,
	}
}

export default function (state = initialState, action) {
	switch (action.type) {
		case conexaoTypes.AdicionarConexaoIda:
			return {
				...state,
				ehConexaoIda: true,
				conexaoIda: action.payload,
				quantidadeViagensIda: action.payload.quantidadeTrechos,
				conexaoIdaId: action.payload.grupoId,
				ordemViagemIda: 0,
			}
		case conexaoTypes.AdicionarConexaoVolta:
			return {
				...state,
				ehConexaoVolta: true,
				ehConexaoIda: false,
				conexaoVolta: action.payload,
				quantidadeViagensVolta: action.payload.quantidadeTrechos,
				conexaoVoltaId: action.payload.grupoId,
				ordemViagemVolta: 0,
			}
		case conexaoTypes.OrdemViagemIda:
			return {
				...state,
				ordemViagemIda: state.ordemViagemIda + 1,
			}
		case conexaoTypes.OrdemViagemVolta:
			return {
				...state,
				ordemViagemVolta: state.ordemViagemVolta + 1,
			}
		case conexaoTypes.ObterConexao:
			return {
				...state,
			}
		case conexaoTypes.ResetConexao:
			return initialState
		default:
			return state
	}
}

export const conexaoActions = {
	setViagemIda,
	setOrdemViagemIda,
	getConexaoState,
	setViagemVolta,
	setOrdemViagemVolta,
	resetConexaoState,
}
